import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page wallet-page" }
const _hoisted_2 = { class: "balance-hero" }
const _hoisted_3 = { class: "balance-amount mono" }
const _hoisted_4 = { class: "balance-fiat text-muted mono" }
const _hoisted_5 = {
  key: 0,
  class: "boarding-status"
}
const _hoisted_6 = { class: "casino-card section-card" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "method-tabs" }
const _hoisted_9 = {
  key: 0,
  class: "section-body"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "hint"
}
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = ["min", "max"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "hint"
}
const _hoisted_16 = {
  key: 1,
  class: "swap-result"
}
const _hoisted_17 = { class: "mono" }
const _hoisted_18 = {
  key: 1,
  class: "section-body"
}
const _hoisted_19 = { class: "mono" }
const _hoisted_20 = {
  key: 2,
  class: "section-body"
}
const _hoisted_21 = { class: "mono" }
const _hoisted_22 = {
  key: 0,
  class: "boarding-list"
}
const _hoisted_23 = { class: "mono" }
const _hoisted_24 = { class: "text-muted boarding-conf" }
const _hoisted_25 = { class: "casino-card section-card" }
const _hoisted_26 = { class: "section-header" }
const _hoisted_27 = { class: "method-tabs" }
const _hoisted_28 = {
  key: 0,
  class: "section-body"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "hint"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "swap-result"
}
const _hoisted_33 = {
  key: 1,
  class: "section-body"
}
const _hoisted_34 = { class: "input-row" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 2,
  class: "section-body"
}
const _hoisted_37 = { class: "input-row" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "casino-card section-card"
}
const _hoisted_40 = { class: "section-body" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "casino-card section-card settings-card" }
const _hoisted_43 = { class: "settings-row" }
const _hoisted_44 = { class: "modal-card casino-card-glow" }
const _hoisted_45 = { class: "mono" }
const _hoisted_46 = { class: "modal-card casino-card-glow" }
const _hoisted_47 = { class: "modal-actions" }
const _hoisted_48 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "balance-eyebrow" }, "YOUR BALANCE", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString($setup.store.getters['ark/formattedBalance'] || '0') + " ", 1),
        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "balance-unit" }, "sats", -1))
      ]),
      _createElementVNode("div", _hoisted_4, "≈ $" + _toDisplayString($setup.usdBalance), 1),
      ($setup.boardingBalance > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString($setup.boardingBalance.toLocaleString()) + " sats boarding ", 1),
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-muted" }, "— settling into Ark", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[38] || (_cache[38] = _createElementVNode("h3", { class: "section-title" }, "Deposit", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.depositMethod === 'lightning' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.depositMethod = 'lightning'))
          }, " ⚡ Lightning ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.depositMethod === 'ark' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.depositMethod = 'ark'))
          }, " Ark ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.depositMethod === 'onchain' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.depositMethod = 'onchain'))
          }, " On-chain ", 2)
        ])
      ]),
      ($setup.depositMethod === 'lightning')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (!$setup.depositInvoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  ($setup.fees && $setup.limits)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.limits.min.toLocaleString()) + " – " + _toDisplayString($setup.limits.max.toLocaleString()) + " sats · " + _toDisplayString($setup.fees.reverse.percentage) + "% + " + _toDisplayString(($setup.fees.reverse.minerFees.lockup + $setup.fees.reverse.minerFees.claim).toLocaleString()) + " fee ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      type: "number",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.depositAmount) = $event)),
                      placeholder: "Amount in sats",
                      min: $setup.limits?.min,
                      max: $setup.limits?.max
                    }, null, 8, _hoisted_13), [
                      [
                        _vModelText,
                        $setup.depositAmount,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "btn-primary",
                      disabled: !$setup.depositAmount || $setup.depositLoading,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.createLnDeposit && $setup.createLnDeposit(...args)))
                    }, _toDisplayString($setup.depositLoading ? 'Creating...' : 'Generate Invoice'), 9, _hoisted_14)
                  ]),
                  ($setup.depositAmount && $setup.fees)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[39] || (_cache[39] = _createTextVNode(" You receive ≈ ", -1)),
                        _createElementVNode("strong", null, _toDisplayString($setup.calcReceive($setup.depositAmount).toLocaleString()), 1),
                        _cache[40] || (_cache[40] = _createTextVNode(" sats after fees ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-badge", $setup.depositStatus])
                  }, _toDisplayString($setup.depositStatusText), 3),
                  _createElementVNode("div", {
                    class: "address-box",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.copyText($setup.depositInvoice)))
                  }, [
                    _createElementVNode("code", _hoisted_17, _toDisplayString($setup.depositInvoice), 1),
                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "btn-outline btn-sm",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.resetDeposit && $setup.resetDeposit(...args)))
                  }, "New Deposit")
                ]))
          ]))
        : _createCommentVNode("", true),
      ($setup.depositMethod === 'ark')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "address-box",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.copyText($setup.arkAddress)))
            }, [
              _createElementVNode("code", _hoisted_19, _toDisplayString($setup.arkAddress || 'Generating...'), 1),
              _cache[42] || (_cache[42] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
            ]),
            ($setup.isMutinyTestnet)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-primary",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.requestFaucet && $setup.requestFaucet(...args)))
                }, " Request Testnet Faucet "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ($setup.depositMethod === 'onchain')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "hint" }, " Send BTC on-chain to your boarding address. Funds need to confirm, then settle into Ark. ", -1)),
            _createElementVNode("div", {
              class: "address-box",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.copyText($setup.boardingAddress)))
            }, [
              _createElementVNode("code", _hoisted_21, _toDisplayString($setup.boardingAddress || 'Generating...'), 1),
              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
            ]),
            ($setup.boardingUtxos.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.boardingUtxos, (utxo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: utxo.outpoint.txid + ':' + utxo.outpoint.vout,
                      class: "boarding-item"
                    }, [
                      _cache[44] || (_cache[44] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(Number(utxo.amount).toLocaleString()) + " sats", 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(utxo.confirmations ? utxo.confirmations + ' conf' : 'unconfirmed') + " — " + _toDisplayString(utxo.confirmations >= 1 ? 'settling into Ark' : 'waiting for confirmation'), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "section-title" }, "Withdraw", -1)),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.withdrawMethod === 'lightning' }]),
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.withdrawMethod = 'lightning'))
          }, " ⚡ Lightning ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.withdrawMethod === 'ark' }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.withdrawMethod = 'ark'))
          }, " Ark ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(['tab', { active: $setup.withdrawMethod === 'onchain' }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.withdrawMethod = 'onchain'))
          }, " On-chain ", 2)
        ])
      ]),
      ($setup.withdrawMethod === 'lightning')
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            ($setup.withdrawStatus === 'idle')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  ($setup.fees && $setup.limits)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.limits.min.toLocaleString()) + " – " + _toDisplayString($setup.limits.max.toLocaleString()) + " sats · " + _toDisplayString($setup.fees.submarine.percentage) + "% + " + _toDisplayString($setup.fees.submarine.minerFees.toLocaleString()) + " fee ", 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.withdrawInvoice) = $event)),
                    placeholder: "Paste Lightning invoice (lnbc...)"
                  }, null, 512), [
                    [_vModelText, $setup.withdrawInvoice]
                  ]),
                  _createElementVNode("button", {
                    class: "btn-primary",
                    disabled: !$setup.withdrawInvoice || $setup.withdrawLoading,
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.createLnWithdraw && $setup.createLnWithdraw(...args)))
                  }, _toDisplayString($setup.withdrawLoading ? 'Paying...' : 'Pay via Lightning'), 9, _hoisted_31)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-badge", $setup.withdrawStatus])
                  }, _toDisplayString($setup.withdrawStatusText), 3),
                  _createElementVNode("button", {
                    class: "btn-outline btn-sm",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.resetWithdraw && $setup.resetWithdraw(...args)))
                  }, "New Withdrawal")
                ]))
          ]))
        : _createCommentVNode("", true),
      ($setup.withdrawMethod === 'ark')
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.withdrawAddress) = $event)),
              placeholder: "Destination Ark address"
            }, null, 512), [
              [_vModelText, $setup.withdrawAddress]
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "number",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.withdrawAmount) = $event)),
                placeholder: "Amount (sats)",
                min: "0"
              }, null, 512), [
                [_vModelText, $setup.withdrawAmount]
              ]),
              _createElementVNode("button", {
                class: "btn-outline btn-sm",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.setMaxAmount && $setup.setMaxAmount(...args)))
              }, "MAX")
            ]),
            _createElementVNode("button", {
              class: "btn-primary",
              disabled: !$setup.withdrawAddress || !$setup.withdrawAmount,
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.withdrawFunds && $setup.withdrawFunds(...args)))
            }, " Send ", 8, _hoisted_35)
          ]))
        : _createCommentVNode("", true),
      ($setup.withdrawMethod === 'onchain')
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "hint" }, " Withdraw to a Bitcoin address on-chain. This triggers a collaborative redeem via the Ark server. ", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.onchainWithdrawAddress) = $event)),
              placeholder: "Bitcoin address (bc1...)"
            }, null, 512), [
              [_vModelText, $setup.onchainWithdrawAddress]
            ]),
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "number",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.onchainWithdrawAmount) = $event)),
                placeholder: "Amount (sats)",
                min: "0"
              }, null, 512), [
                [
                  _vModelText,
                  $setup.onchainWithdrawAmount,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "btn-outline btn-sm",
                onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.onchainWithdrawAmount = Math.max(0, Number($setup.store.getters['ark/balance'] || 0) - 300)))
              }, "MAX")
            ]),
            _createElementVNode("button", {
              class: "btn-primary",
              disabled: !$setup.onchainWithdrawAddress || !$setup.onchainWithdrawAmount,
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.withdrawOnchain && $setup.withdrawOnchain(...args)))
            }, " Withdraw On-chain ", 8, _hoisted_38)
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.hasUnsettledFunds)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "section-header" }, [
            _createElementVNode("h3", { class: "section-title" }, "Settle Funds")
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "hint" }, " You have unsettled funds (boarding or preconfirmed). Settle them into the Ark round to make them spendable. ", -1)),
            _createElementVNode("button", {
              class: "btn-primary",
              disabled: $setup.settleLoading,
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.settleFunds && $setup.settleFunds(...args)))
            }, _toDisplayString($setup.settleLoading ? 'Settling...' : 'Settle Now'), 9, _hoisted_41)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_42, [
      _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "section-title" }, "Settings", -1)),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("button", {
          class: "btn-outline",
          onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.showKey = true))
        }, "Back Up Key"),
        _createElementVNode("button", {
          class: "btn-danger",
          onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.showDeleteConfirm = true))
        }, "Delete Wallet")
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.showKey)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "overlay",
              onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => ($setup.showKey = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_44, [
                _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "modal-title text-gold" }, "Private Key", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("p", { class: "modal-desc text-muted" }, "Never share this with anyone.", -1)),
                _createElementVNode("div", {
                  class: "key-display",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.copyText($setup.privateKey)))
                }, [
                  _createElementVNode("code", _hoisted_45, _toDisplayString($setup.privateKey), 1),
                  _cache[51] || (_cache[51] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
                ]),
                _createElementVNode("button", {
                  class: "btn-outline",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.showKey = false))
                }, "Close")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.showDeleteConfirm)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "overlay",
              onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => ($setup.showDeleteConfirm = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_46, [
                _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "modal-title text-red" }, "Delete Wallet", -1)),
                _cache[55] || (_cache[55] = _createElementVNode("p", { class: "modal-desc text-muted" }, "This cannot be undone. Type DELETE to confirm.", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.deleteConfirmText) = $event)),
                  placeholder: "DELETE"
                }, null, 512), [
                  [_vModelText, $setup.deleteConfirmText]
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("button", {
                    class: "btn-outline",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.showDeleteConfirm = false))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "btn-danger",
                    disabled: $setup.deleteConfirmText !== 'DELETE',
                    onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.deleteWallet && $setup.deleteWallet(...args)))
                  }, " Delete ", 8, _hoisted_48)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        ($setup.toastMsg)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["toast", $setup.toastType])
            }, _toDisplayString($setup.toastMsg), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}